var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',_vm._l((_vm.textParts),function(part,index){return _c('span',{key:index},[(_vm.isHashtag(part))?[_c('a',{staticClass:"as-link colour-primary font-bold",on:{"click":(e) => _vm.tagClick(e, part)}},[_vm._v(_vm._s(part))])]:_c('span',{domProps:{"innerHTML":_vm._s(_vm.nl2br(_vm.hasLinkedText(part)))}})],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }